export const ID_EMPRESA = {
    PLASTICO: 6056,
    SECOBOL: 8907,
    ORANGE: 4304,
};

export const ID_ESTADOS_POR_EMPRESA = {
    PLASTICO: {
        ENTREGA_PARCIAL: 'c351718b-f2d7-11f0-800f-42010a8e000b',
        NO_ENTREGADO: '6442814a-d1e7-11f0-800f-42010a8e000b',
    },
    SECOBOL: {
        ENTREGA_PARCIAL: 'fd312349-faef-11f0-800f-42010a8e000b',
        RECHAZADO: '23e68ce4-faf0-11f0-800f-42010a8e000b',
    },
};